<template>
  <div class="tagListSimple">
    <ul>
      <li v-for="(el, idx) in tagList" :key="idx">
        <a href="" @click.prevent="handleClick(el)">{{ `# ${el.tagName}` }}</a>
      </li>
    </ul>
  </div>
</template>

<script>
import { beforeSendLog } from '@/utils'

export default {
  name: 'TagListSimple',
  props: {
    tagList: {
      type: Array,
      default: ()=>[]
    }
  },
  methods: {
    handleClick(tag) {
      beforeSendLog('Tag', {TagName: tag.tagName})
      this.$router.push(`/tagList/${encodeURIComponent(tag.tagName)}`)
    }
  }
}
</script>

<style scoped>
.tagListSimple {
  background-color: #fff;
}
ul {
  border-top: 1px solid #efefef;
  border-bottom: 1px solid #efefef;
  padding: 10px 16px 3px;
}
ul:empty {
  border-top: none;
  border-bottom: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 7px 7px 0;
  max-width: 100%;
}
a {
  display: block;
  padding: 6.5px 12px;
  color: #57575c;
  font-size: 12px;
  border: 1px solid #d6d6db;
  border-radius: 14px;
  word-break: break-all;
}
</style>

